// accounts.js
export default (Alpine) => {
    Alpine.data("accountNav", () => ({
        swiper: null,
        points: 0,
        pointsBalance: '0 points',
        menuOpen: false,

        init() {
          this.hydrate();

          this.onPageShow = (e) => {
              this.hydrate();
          };
          window.addEventListener('pageshow', this.onPageShow);
        },

        hydrate() {
          const store = Alpine.store('accountNav');
          if (!store || store.points == null) {
            this.pollSwell();
          } else {
            this.points = store.points;
            this.pointsBalance = store.pointsBalance;
          }
        },

        fetchYotpoData() {
            const els = document.querySelectorAll('.yotpo-points');

            if (!els?.length) return;
          
            const customer = window.swellConfig?.customer;
            const points = customer?.points_balance;
          
            if (points == null || Number.isNaN(Number(points))) return;
          
            this.points = points;
            this.pointsBalance = points + ' points';

            Alpine.store('accountNav', {
              points: points,
              pointsBalance: points + ' points',
            });

            if (points && points > 0) {
                els.forEach(el => {
                    el.classList.remove('hidden');
                });
            } else {
                els.forEach(el => {
                    el.classList.add('hidden');
                });
            }
        },
          
        pollSwell() {
            const els = document.querySelectorAll('.yotpo-points');

            if (!els?.length) return;
          
            let tries = 0;
            const maxTries = 20; 
            const intervalMs = 2000;
          
            const interval = setInterval(() => {
              const customer = window.swellConfig?.customer;
              const points = customer?.points_balance;

              this.points = points;
              this.pointsBalance = points + ' points';

              Alpine.store('accountNav', {
                points: points,
                pointsBalance: points + ' points',
              });
          
              if (points != null) {
                clearInterval(interval);
                this.fetchYotpoData();
                return;
              }
          
              tries++;
              if (tries >= maxTries) clearInterval(interval);
            }, intervalMs);
        }
          
    }));
  };